import React from "react";
import { motion } from "motion/react";

import heroBg from "../assets/black-marble-texture-background.jpg";
import logo from "../assets/Luke-Archer-Logo_Orange.png";
import cv from "../assets/Luke Archer CV.pdf";

const Hero: React.FC = () => {
    return (
        <section
            className="relative w-full bg-cover bg-center p-5"
            style={{ backgroundImage: `url(${heroBg})` }}
        >
            <div className="absolute inset-0 bg-black opacity-60"></div>

            {/* Box border animation */}
            <motion.div
                className="absolute inset-0 m-5 border-4 border-orange pointer-events-none"
                initial={{ width: 0, height: 0 }}
                animate={{ width: "calc(100% - 2.5rem)", height: "calc(100% - 2.5rem)" }}
                transition={{ duration: 1.5, ease: "easeInOut" }}
                style={{ position: "absolute" }}
            ></motion.div>

            {/* Content inside the box */}
            <div className="relative z-10 m-5 p-5 flex flex-col lg:flex-row items-center lg:items-start bg-transparent">
                {/* Logo */}
                <motion.img
                    className="w-40 h-40 mb-5 lg:mb-0 lg:mr-5"
                    src={logo}
                    alt="Luke Archer Logo"
                    initial={{ y: -100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 1, ease: "easeOut" }}
                />

                <div className="lg:ml-5">
                    <h1 className="text-white font-euro text-4xl">Luke Archer</h1>
                    <h2 className="text-white font-euro text-2xl">Graphic Designer</h2>
                    
                    {/* Line animation */}
                    <motion.div
                        className="border-t-2 border-orange my-5"
                        initial={{ scaleX: 0 }}
                        animate={{ scaleX: 1 }}
                        transition={{ duration: 1.2, ease: "easeInOut" }}
                        style={{ transformOrigin: "left" }}
                    ></motion.div>

                    <p className="text-white font-frankbook sm:text-md lg:text-lg">
                        With expertise in crafting impactful designs across print and digital media, 
                        I have over 6 years experience in advertising, events, and online content. 
                        With experience managing numerous clients and projects, I take pride delivering visually 
                        compelling work that connects with audiences and elevates brand presence.
                    </p>

                    <a href={cv} download="Luke Archer CV.pdf">
                        <button className="text-white bg-orange duration-300 ease-in-out hover:bg-purple font-euro w-full lg:w-auto py-1 px-4 mt-5">
                            Download my CV
                        </button>
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Hero;
